import type { LayoutConstraints, TypedGroupviewPanelState } from '../../../../types/LayoutConfig';
import { LEAF } from '../../../Layout/tokens';

export const ONLY_WHEN_VISIBLE = 'onlyWhenVisible';

export const DEFAULT_MIN_SIZE = 100;
export const DEFAULT_WATCHLIST_WIDTH = 480;
export const MIN_WATCHLIST_WIDTH = 480;
export const MAX_WATCHLIST_WIDTH = MIN_WATCHLIST_WIDTH + 120;
export const DEFAULT_OMS_WIDTH = 370;
export const MIN_OMS_WIDTH = DEFAULT_OMS_WIDTH;
export const MAX_OMS_WIDTH = 540;

export const BLOTTER_PANELS: Record<string, TypedGroupviewPanelState> = {
  orders: {
    id: 'orders',
    contentComponent: 'ordersBlotter',
    title: 'Orders',
    tabComponent: 'readOnly',
    params: {
      type: 'ordersBlotter',
    },
  },
  trades: {
    id: 'trades',
    contentComponent: 'tradesBlotter',
    title: 'Trades',
    tabComponent: 'readOnly',
    params: {
      type: 'tradesBlotter',
    },
  },
  rfqs: {
    id: 'rfqs',
    contentComponent: 'rfqsBlotter',
    title: 'RFQs',
    params: {
      type: 'rfqsBlotter',
    },
  },
  otcDerivatives: {
    id: 'otcDerivatives',
    contentComponent: 'otcDerivatives',
    title: 'OTC Derivatives',
    params: {
      type: 'otcDerivatives',
    },
  },
  loans: {
    id: 'loans',
    contentComponent: 'loans',
    title: 'Loans',
    params: {
      type: 'loans',
    },
  },
  positions: {
    id: 'positions',
    contentComponent: 'positionsBlotter',
    title: 'Positions',
    params: {
      type: 'positionsBlotter',
    },
  },
  balances: {
    id: 'balances',
    contentComponent: 'balancesBlotter',
    title: 'Balances',
    params: {
      type: 'balancesBlotter',
    },
  },
  credit: {
    id: 'credit',
    contentComponent: 'creditBlotter',
    title: 'Credit',
    params: {
      type: 'creditBlotter',
    },
  },
  transfers: {
    id: 'transfers',
    contentComponent: 'transfersBlotter',
    title: 'Transfers',
    params: {
      type: 'transfersBlotter',
    },
  },
  allocations: {
    id: 'allocations',
    contentComponent: 'allocations',
    title: 'Allocations',
    params: {
      type: 'allocations',
    },
  },
  reconMismatches: {
    id: 'reconMismatches',
    contentComponent: 'reconMismatches',
    title: 'Reconciliation Mismatches',
    params: {
      type: 'reconMismatches',
    },
  },
  hedgePositionStatus: {
    id: 'hedgePositionStatus',
    contentComponent: 'hedgePositionStatus',
    title: 'Position Autohedging',
    params: {
      type: 'hedgePositionStatus',
    },
  },
};

const { allocations: _allocations, ...blotterPanelsWithoutAllocations } = BLOTTER_PANELS;

export const BLOTTER_PANELS_WITHOUT_ALLOCATIONS = blotterPanelsWithoutAllocations;

export const BLOTTERS_GROUP = {
  type: LEAF,
  data: {
    views: [
      'orders',
      'trades',
      'otcDerivatives',
      'loans',
      'rfqs',
      'positions',
      'reconMismatches',
      'balances',
      'credit',
      'transfers',
      'allocations',
      'hedgePositionStatus',
    ],
    activeView: 'orders',
    id: 'blotters',
  },
  minimumWidth: 0,
  size: 200,
};

export const WATCHLIST_CONSTRAINTS: LayoutConstraints = {
  groupId: 'watchlists',
  panelIds: ['watchlist'],
  minWidth: MIN_WATCHLIST_WIDTH,
};
